export default class AJAXForm {

	constructor(form, options) {
		this.options = Object.assign({
			resetOnSuccess: true,
			destroyOnSuccess: false,
		}, options);

		this.form = form;
		this.errors = [];
		this.debug = [];
		this.success = [];
		this.warnings = [];

		this._submit = [];
		this._fail = [];
		this._done = [];
		this._always = [];

		this.form.ajaxForm = this;

		this._init();
	}

	_init() {
		let clicked = null;

		this.form.addEventListener('click', e => {
			if(e.target.type === 'submit') {
				clicked = e.target;
			}
		});

		this.form.addEventListener('submit', e => {
			e.preventDefault();

			if(clicked && clicked.name) {
				let data = {};

				data[clicked.name] = clicked.value;

				this.submit(data);
			} else {
				this.submit();
			}

			clicked = null;
		});
	}

	_updateMessages(data) {
		data = data || {};

		if(data.messages) {
			this.errors = data.messages.errors || [];
			this.debug = data.messages.debug || [];
			this.warnings = data.messages.warnings || [];
			this.success = data.messages.success || [];
		} else {
			data.messages = {
				errors: [],
				warnings: [],
				success: [],
				debug: [],
			};
		}
	}

	_sendRequest(data) {
		fetch(this.form.action, {
			method: this.form.method,
			mode: 'same-origin',
			credentials: 'same-origin',
			cache: 'default',
			redirect: 'error',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
			},
			body: data,
		}).then((response) => {
			response.json().then(data => {
				this._updateMessages(data);

				if(data.success) {
					for(let i = 0; i < this._done.length; i++) {
						this._done[i].call(this, data, null);
					}

					if(this.options.resetOnSuccess) {
						this.form.reset()
					}

					if(this.options.destroyOnSuccess) {
						this.destroy();
					}
				} else {
					for(let j = 0; j < this._fail.length; j++) {
						this._fail[j].call(this, data, null, this.errors.join('\n'));
					}
				}
			});

			
		}, reason => {
			for(let i = 0; i < this._fail.length; i++) {
				this._fail[i].call(this, null, reason, '');
			}
		}).finally(() => {
			for(let i = 0; i < this.form.elements.length; i++) {
				const element = this.form.elements.item(i);

				if(element.type !== 'submit') {
					continue;
				}

				element.disabled = false;
				element.textContent = element.oldLabel;
			}

			for(let i = 0; i < this._always.length; i++) {
				this._always[i].call(this);
			}
		});
	}

	static _serializeArray(form) {
		let result = [];

		if(form.elements) {
			for(let i = 0; i < form.elements.length; i++) {
				const field = form.elements.item(i);

				if(!field.name || field.disabled) {
					continue;
				}

				if(field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') {
					continue;
				}

				if(field.type === 'select-multiple') {
					for(let i = 0; i < field.options.length; i++) {
						const option = field.options.item(i);

						if(option.selected) {
							result.push({
								name: field.name,
								value: option.value,
							});
						}
					}
				} else if((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
					result.push({
						name: field.name,
						value: field.value,
					});
				}
			}
		}

		return result;
	}
}

//noinspection JSUnusedGlobalSymbols
AJAXForm.prototype.getErrors = function() {
	return this.errors;
};

//noinspection JSUnusedGlobalSymbols
AJAXForm.prototype.getSuccess = function() {
	return this.success;
};

//noinspection JSUnusedGlobalSymbols
AJAXForm.prototype.getWarnings = function() {
	return this.warnings;
};

//noinspection JSUnusedGlobalSymbols
AJAXForm.prototype.getDebug = function() {
	return this.debug;
};

AJAXForm.prototype.getErrorString = function() {
	let errors = [];

	for(let field in this.errors) {
		if(this.errors.hasOwnProperty(field)) {
			let error = this.errors[field];

			errors.push((typeof error.count !== 'undefined') ? error.join('\n') : error);
		}
	}

	return errors.join('\n');
};

AJAXForm.prototype.submit = function(extraData) {
	let data = {};

	if(this.options.data) {
		data = this.options.data.call(this, this.form);
	} else {
		let rawData = AJAXForm._serializeArray(this.form);

		for(let i = 0; i < rawData.length; i++) {
			let field = rawData[i];

			//Hack for arrays
			if(field.name.match(/\[]$/)) {
				field.name.replace('[]', '');

				data[field.name] = data[field.name] || [];
				data[field.name].push(field.value);
			} else {
				data[field.name] = field.value;
			}
		}
	}

	if(extraData) {
		data = Object.assign(data, extraData);
	}

	for(let i = 0; i < this.form.elements.length; i++) {
		const element = this.form.elements.item(i);

		if(element.type !== 'submit') {
			continue;
		}

		element.disabled = true;

		element.oldLabel = element.textContent;
		element.textContent = element.dataset.submit || 'Submitting...';
	}

	this.form.querySelectorAll('.alert').forEach(element => {
		element.remove();
	});

	for(let j = 0; j < this._submit.length; j++) {
		this._submit[j].call(this, data);
	}

	data = Object.keys(data)
		.map(k => encodeURIComponent(k) + '=' + encodeURIComponent(data[k]))
		.join('&');

	this._sendRequest(data);
};

AJAXForm.prototype.done = function(callback) {
	this._done.push(callback);
	return this;
};

AJAXForm.prototype.fail = function(callback) {
	this._fail.push(callback);
	return this;
};

AJAXForm.prototype.always = function(callback) {
	this._always.push(callback);
	return this;
};

// noinspection JSUnusedGlobalSymbols
AJAXForm.prototype.preSubmit = function(callback) {
	this._submit.push(callback);
	return this;
};

AJAXForm.prototype.destroy = function() {
	delete this.form.ajaxForm;
	delete this.form;
};